// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/runner_manager.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { SupportedModel } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { LogLevel } from "./runner_pb";
import { file_gitpod_v1_runner } from "./runner_pb";
import type { LLMIntegrationRequestHeader, SCMIntegrationOAuthConfig } from "./runner_configuration_pb";
import { file_gitpod_v1_runner_configuration } from "./runner_configuration_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/runner_manager.proto.
 */
export const file_gitpod_v1_runner_manager: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_agent, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_gitpod_v1_runner, file_gitpod_v1_runner_configuration, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.RunnerManager
 */
export type RunnerManager = Message<"gitpod.v1.RunnerManager"> & {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId: string;

  /**
   * Time when the RunnerManager was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Time when the RunnerManager was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * The runner manager's name which is shown to users
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * Region where the runner manager operates
   *
   * @generated from field: string region = 5;
   */
  region: string;

  /**
   * The runner manager's configuration (DEPRECATED: Use spec.configuration instead)
   *
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 6 [deprecated = true];
   * @deprecated
   */
  configuration?: RunnerManagerConfiguration;

  /**
   * creator is the identity of the creator of the runner manager
   *
   * @generated from field: gitpod.v1.Subject creator = 7;
   */
  creator?: Subject;

  /**
   * The runner manager's specification
   *
   * @generated from field: gitpod.v1.RunnerManagerSpec spec = 8;
   */
  spec?: RunnerManagerSpec;

  /**
   * The current phase of the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase phase = 9 [deprecated = true];
   * @deprecated
   */
  phase: RunnerManagerPhase;

  /**
   * The current status of the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerStatus status = 10;
   */
  status?: RunnerManagerStatus;
};

/**
 * Describes the message gitpod.v1.RunnerManager.
 * Use `create(RunnerManagerSchema)` to create a new message.
 */
export const RunnerManagerSchema: GenMessage<RunnerManager> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 0);

/**
 * @generated from message gitpod.v1.CreateRunnerManagerRequest
 */
export type CreateRunnerManagerRequest = Message<"gitpod.v1.CreateRunnerManagerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 3;
   */
  configuration?: RunnerManagerConfiguration;
};

/**
 * Describes the message gitpod.v1.CreateRunnerManagerRequest.
 * Use `create(CreateRunnerManagerRequestSchema)` to create a new message.
 */
export const CreateRunnerManagerRequestSchema: GenMessage<CreateRunnerManagerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 1);

/**
 * @generated from message gitpod.v1.CreateRunnerManagerResponse
 */
export type CreateRunnerManagerResponse = Message<"gitpod.v1.CreateRunnerManagerResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerManager runner_manager = 1;
   */
  runnerManager?: RunnerManager;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;
};

/**
 * Describes the message gitpod.v1.CreateRunnerManagerResponse.
 * Use `create(CreateRunnerManagerResponseSchema)` to create a new message.
 */
export const CreateRunnerManagerResponseSchema: GenMessage<CreateRunnerManagerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 2);

/**
 * @generated from message gitpod.v1.GetRunnerManagerRequest
 */
export type GetRunnerManagerRequest = Message<"gitpod.v1.GetRunnerManagerRequest"> & {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId: string;
};

/**
 * Describes the message gitpod.v1.GetRunnerManagerRequest.
 * Use `create(GetRunnerManagerRequestSchema)` to create a new message.
 */
export const GetRunnerManagerRequestSchema: GenMessage<GetRunnerManagerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 3);

/**
 * @generated from message gitpod.v1.GetRunnerManagerResponse
 */
export type GetRunnerManagerResponse = Message<"gitpod.v1.GetRunnerManagerResponse"> & {
  /**
   * @generated from field: gitpod.v1.RunnerManager runner_manager = 1;
   */
  runnerManager?: RunnerManager;
};

/**
 * Describes the message gitpod.v1.GetRunnerManagerResponse.
 * Use `create(GetRunnerManagerResponseSchema)` to create a new message.
 */
export const GetRunnerManagerResponseSchema: GenMessage<GetRunnerManagerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 4);

/**
 * @generated from message gitpod.v1.RunnerManagerSpec
 */
export type RunnerManagerSpec = Message<"gitpod.v1.RunnerManagerSpec"> & {
  /**
   * @generated from field: gitpod.v1.RunnerManagerConfiguration configuration = 1;
   */
  configuration?: RunnerManagerConfiguration;

  /**
   * The desired phase for the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase desired_phase = 2;
   */
  desiredPhase: RunnerManagerPhase;
};

/**
 * Describes the message gitpod.v1.RunnerManagerSpec.
 * Use `create(RunnerManagerSpecSchema)` to create a new message.
 */
export const RunnerManagerSpecSchema: GenMessage<RunnerManagerSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 5);

/**
 * @generated from message gitpod.v1.RunnerManagerStatus
 */
export type RunnerManagerStatus = Message<"gitpod.v1.RunnerManagerStatus"> & {
  /**
   * The actual phase of the runner manager as reported by the system
   *
   * @generated from field: gitpod.v1.RunnerManagerPhase phase = 1;
   */
  phase: RunnerManagerPhase;
};

/**
 * Describes the message gitpod.v1.RunnerManagerStatus.
 * Use `create(RunnerManagerStatusSchema)` to create a new message.
 */
export const RunnerManagerStatusSchema: GenMessage<RunnerManagerStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 6);

/**
 * @generated from message gitpod.v1.RunnerManagerConfiguration
 */
export type RunnerManagerConfiguration = Message<"gitpod.v1.RunnerManagerConfiguration"> & {
  /**
   * @generated from field: repeated gitpod.v1.StaticSCMIntegration scm_integration_templates = 1;
   */
  scmIntegrationTemplates: StaticSCMIntegration[];

  /**
   * metrics contains configuration for the runner manager's metrics collection
   *
   * @generated from field: gitpod.v1.RunnerManagerMetricsConfiguration metrics = 2;
   */
  metrics?: RunnerManagerMetricsConfiguration;

  /**
   * log_level is the log level for the runner manager
   *
   * @generated from field: gitpod.v1.LogLevel log_level = 3;
   */
  logLevel: LogLevel;

  /**
   * @generated from field: repeated gitpod.v1.StaticLLMIntegration llm_integration_templates = 4;
   */
  llmIntegrationTemplates: StaticLLMIntegration[];

  /**
   * The release channel for the runner manager
   *
   * @generated from field: gitpod.v1.RunnerManagerReleaseChannel release_channel = 5;
   */
  releaseChannel: RunnerManagerReleaseChannel;

  /**
   * When set to true, the runner manager collects pprof profiles and uploads
   * them to the logs S3 bucket. The runner manager resets this flag after
   * collection so it acts as a one-shot trigger.
   *
   * @generated from field: bool collect_debug_profile = 6;
   */
  collectDebugProfile: boolean;
};

/**
 * Describes the message gitpod.v1.RunnerManagerConfiguration.
 * Use `create(RunnerManagerConfigurationSchema)` to create a new message.
 */
export const RunnerManagerConfigurationSchema: GenMessage<RunnerManagerConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 7);

/**
 * @generated from message gitpod.v1.StaticSCMIntegration
 */
export type StaticSCMIntegration = Message<"gitpod.v1.StaticSCMIntegration"> & {
  /**
   * @generated from field: string scm_id = 1;
   */
  scmId: string;

  /**
   * @generated from field: string host = 2;
   */
  host: string;

  /**
   * @generated from field: gitpod.v1.SCMIntegrationOAuthConfig oauth = 3;
   */
  oauth?: SCMIntegrationOAuthConfig;

  /**
   * @generated from field: bool pat = 4;
   */
  pat: boolean;

  /**
   * virtual_directory is the virtual directory path for Azure DevOps Server (e.g., "/tfs").
   * This field is only used for Azure DevOps Server SCM integrations and should be empty for other SCM types.
   * Azure DevOps Server APIs work without collection when PAT scope is 'All accessible organizations'.
   *
   * @generated from field: optional string virtual_directory = 5;
   */
  virtualDirectory?: string;
};

/**
 * Describes the message gitpod.v1.StaticSCMIntegration.
 * Use `create(StaticSCMIntegrationSchema)` to create a new message.
 */
export const StaticSCMIntegrationSchema: GenMessage<StaticSCMIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 8);

/**
 * @generated from message gitpod.v1.StaticLLMIntegration
 */
export type StaticLLMIntegration = Message<"gitpod.v1.StaticLLMIntegration"> & {
  /**
   * id is a unique identifier for the LLM integration template.
   * This field must be provided by the client when creating the integration.
   * It is required for identifying and updating the integration, since there is no other unique identifier.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * models represents the LLM models this integration supports
   *
   * @generated from field: repeated gitpod.v1.SupportedModel models = 2;
   */
  models: SupportedModel[];

  /**
   * @generated from field: string endpoint = 3;
   */
  endpoint: string;

  /**
   * encrypted_api_key is the LLM provider's API key encrypted with the runner's public key.
   *
   * @generated from field: bytes encrypted_api_key = 4;
   */
  encryptedApiKey: Uint8Array;

  /**
   * max_tokens is the maximum number of tokens to generate before stopping. 0 is a model default.
   *
   * @generated from field: uint64 max_tokens = 5;
   */
  maxTokens: bigint;

  /**
   * request_headers contains custom request headers for this integration (e.g., for portkey compatibility).
   * Header values will be encrypted with the runner's public key.
   *
   * @generated from field: repeated gitpod.v1.LLMIntegrationRequestHeader request_headers = 6;
   */
  requestHeaders: LLMIntegrationRequestHeader[];
};

/**
 * Describes the message gitpod.v1.StaticLLMIntegration.
 * Use `create(StaticLLMIntegrationSchema)` to create a new message.
 */
export const StaticLLMIntegrationSchema: GenMessage<StaticLLMIntegration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 9);

/**
 * @generated from message gitpod.v1.RunnerManagerMetricsConfiguration
 */
export type RunnerManagerMetricsConfiguration = Message<"gitpod.v1.RunnerManagerMetricsConfiguration"> & {
  /**
   * enabled indicates whether the runner should collect metrics
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: string username = 3;
   */
  username: string;

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: string password = 4;
   */
  password: string;
};

/**
 * Describes the message gitpod.v1.RunnerManagerMetricsConfiguration.
 * Use `create(RunnerManagerMetricsConfigurationSchema)` to create a new message.
 */
export const RunnerManagerMetricsConfigurationSchema: GenMessage<RunnerManagerMetricsConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 10);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest
 */
export type UpdateRunnerManagerRequest = Message<"gitpod.v1.UpdateRunnerManagerRequest"> & {
  /**
   * runner_manager_id specifies which runner manager to be updated.
   *
   * +required
   *
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId: string;

  /**
   * The runner manager's name which is shown to users
   *
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * Region where the runner manager operates
   *
   * @generated from field: optional string region = 3;
   */
  region?: string;

  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.Spec spec = 5;
   */
  spec?: UpdateRunnerManagerRequest_Spec;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.
 * Use `create(UpdateRunnerManagerRequestSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequestSchema: GenMessage<UpdateRunnerManagerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration
 */
export type UpdateRunnerManagerRequest_RunnerManagerConfiguration = Message<"gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration"> & {
  /**
   * scm_integration_templates_update contains the new values for the SCM integration templates.
   * when set, the runner manager's SCM integration templates will be replaced with the new templates.
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate scm_integration_templates_update = 1;
   */
  scmIntegrationTemplatesUpdate?: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate;

  /**
   * metrics contains configuration for the runner manager's metrics collection
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration metrics = 2;
   */
  metrics?: UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration;

  /**
   * log_level is the log level for the runner manager
   *
   * @generated from field: optional gitpod.v1.LogLevel log_level = 3;
   */
  logLevel?: LogLevel;

  /**
   * llm_integration_templates_update contains the new values for the LLM integration templates.
   * when set, the runner manager's LLM integration templates will be replaced with the new templates.
   *
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate llm_integration_templates_update = 4;
   */
  llmIntegrationTemplatesUpdate?: UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate;

  /**
   * release_channel can be updated to control the runner manager release channel
   *
   * @generated from field: optional gitpod.v1.RunnerManagerReleaseChannel release_channel = 5;
   */
  releaseChannel?: RunnerManagerReleaseChannel;

  /**
   * When set to true, triggers a one-shot profile collection that uploads
   * pprof profiles to the logs S3 bucket.
   *
   * @generated from field: optional bool collect_debug_profile = 6;
   */
  collectDebugProfile?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.
 * Use `create(UpdateRunnerManagerRequest_RunnerManagerConfigurationSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequest_RunnerManagerConfigurationSchema: GenMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11, 0);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate
 */
export type UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate = Message<"gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate"> & {
  /**
   * @generated from field: repeated gitpod.v1.StaticSCMIntegration scm_integration_templates = 1;
   */
  scmIntegrationTemplates: StaticSCMIntegration[];
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticSCMIntegrationsUpdate.
 * Use `create(UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdateSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdateSchema: GenMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticSCMIntegrationsUpdate> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11, 0, 0);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate
 */
export type UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate = Message<"gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate"> & {
  /**
   * @generated from field: repeated gitpod.v1.StaticLLMIntegration llm_integration_templates = 1;
   */
  llmIntegrationTemplates: StaticLLMIntegration[];
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration.StaticLLMIntegrationsUpdate.
 * Use `create(UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdateSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdateSchema: GenMessage<UpdateRunnerManagerRequest_RunnerManagerConfiguration_StaticLLMIntegrationsUpdate> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11, 0, 1);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration
 */
export type UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration = Message<"gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration"> & {
  /**
   * enabled indicates whether the runner manager should collect metrics
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * url is the URL of the metrics collector
   *
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * username is the username to use for the metrics collector
   *
   * @generated from field: optional string username = 3;
   */
  username?: string;

  /**
   * password is the password to use for the metrics collector
   *
   * @generated from field: optional string password = 4;
   */
  password?: string;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerMetricsConfiguration.
 * Use `create(UpdateRunnerManagerRequest_RunnerManagerMetricsConfigurationSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequest_RunnerManagerMetricsConfigurationSchema: GenMessage<UpdateRunnerManagerRequest_RunnerManagerMetricsConfiguration> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11, 1);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerRequest.Spec
 */
export type UpdateRunnerManagerRequest_Spec = Message<"gitpod.v1.UpdateRunnerManagerRequest.Spec"> & {
  /**
   * @generated from field: optional gitpod.v1.UpdateRunnerManagerRequest.RunnerManagerConfiguration configuration = 1;
   */
  configuration?: UpdateRunnerManagerRequest_RunnerManagerConfiguration;

  /**
   * desired_phase can be updated to control the runner manager state
   *
   * @generated from field: optional gitpod.v1.RunnerManagerPhase desired_phase = 2;
   */
  desiredPhase?: RunnerManagerPhase;
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerRequest.Spec.
 * Use `create(UpdateRunnerManagerRequest_SpecSchema)` to create a new message.
 */
export const UpdateRunnerManagerRequest_SpecSchema: GenMessage<UpdateRunnerManagerRequest_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 11, 2);

/**
 * @generated from message gitpod.v1.UpdateRunnerManagerResponse
 */
export type UpdateRunnerManagerResponse = Message<"gitpod.v1.UpdateRunnerManagerResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateRunnerManagerResponse.
 * Use `create(UpdateRunnerManagerResponseSchema)` to create a new message.
 */
export const UpdateRunnerManagerResponseSchema: GenMessage<UpdateRunnerManagerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 12);

/**
 * @generated from message gitpod.v1.DeleteRunnerManagerRequest
 */
export type DeleteRunnerManagerRequest = Message<"gitpod.v1.DeleteRunnerManagerRequest"> & {
  /**
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId: string;
};

/**
 * Describes the message gitpod.v1.DeleteRunnerManagerRequest.
 * Use `create(DeleteRunnerManagerRequestSchema)` to create a new message.
 */
export const DeleteRunnerManagerRequestSchema: GenMessage<DeleteRunnerManagerRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 13);

/**
 * @generated from message gitpod.v1.DeleteRunnerManagerResponse
 */
export type DeleteRunnerManagerResponse = Message<"gitpod.v1.DeleteRunnerManagerResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteRunnerManagerResponse.
 * Use `create(DeleteRunnerManagerResponseSchema)` to create a new message.
 */
export const DeleteRunnerManagerResponseSchema: GenMessage<DeleteRunnerManagerResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 14);

/**
 * @generated from message gitpod.v1.ListRunnerManagersRequest
 */
export type ListRunnerManagersRequest = Message<"gitpod.v1.ListRunnerManagersRequest"> & {
  /**
   * pagination contains the pagination options for listing runner managers
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListRunnerManagersRequest.
 * Use `create(ListRunnerManagersRequestSchema)` to create a new message.
 */
export const ListRunnerManagersRequestSchema: GenMessage<ListRunnerManagersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 15);

/**
 * @generated from message gitpod.v1.ListRunnerManagersResponse
 */
export type ListRunnerManagersResponse = Message<"gitpod.v1.ListRunnerManagersResponse"> & {
  /**
   * pagination contains the pagination options for listing runner managers
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The runner managers registered in the scope
   *
   * @generated from field: repeated gitpod.v1.RunnerManager runner_managers = 2;
   */
  runnerManagers: RunnerManager[];
};

/**
 * Describes the message gitpod.v1.ListRunnerManagersResponse.
 * Use `create(ListRunnerManagersResponseSchema)` to create a new message.
 */
export const ListRunnerManagersResponseSchema: GenMessage<ListRunnerManagersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 16);

/**
 * @generated from message gitpod.v1.ListAvailableRunnerManagersRequest
 */
export type ListAvailableRunnerManagersRequest = Message<"gitpod.v1.ListAvailableRunnerManagersRequest"> & {
  /**
   * pagination contains the pagination options for listing available runner managers
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;
};

/**
 * Describes the message gitpod.v1.ListAvailableRunnerManagersRequest.
 * Use `create(ListAvailableRunnerManagersRequestSchema)` to create a new message.
 */
export const ListAvailableRunnerManagersRequestSchema: GenMessage<ListAvailableRunnerManagersRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 17);

/**
 * @generated from message gitpod.v1.ListAvailableRunnerManagersResponse
 */
export type ListAvailableRunnerManagersResponse = Message<"gitpod.v1.ListAvailableRunnerManagersResponse"> & {
  /**
   * pagination contains the pagination options for listing available runner managers
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * The runner managers available for the organization
   *
   * @generated from field: repeated gitpod.v1.AvailableRunnerManager runner_managers = 2;
   */
  runnerManagers: AvailableRunnerManager[];
};

/**
 * Describes the message gitpod.v1.ListAvailableRunnerManagersResponse.
 * Use `create(ListAvailableRunnerManagersResponseSchema)` to create a new message.
 */
export const ListAvailableRunnerManagersResponseSchema: GenMessage<ListAvailableRunnerManagersResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 18);

/**
 * @generated from message gitpod.v1.AvailableRunnerManager
 */
export type AvailableRunnerManager = Message<"gitpod.v1.AvailableRunnerManager"> & {
  /**
   * runner_manager_id is the unique identifier of the runner manager
   *
   * @generated from field: string runner_manager_id = 1;
   */
  runnerManagerId: string;

  /**
   * name is the human-readable name of the runner manager
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * region is the region where the runner manager is located
   *
   * @generated from field: string region = 3;
   */
  region: string;
};

/**
 * Describes the message gitpod.v1.AvailableRunnerManager.
 * Use `create(AvailableRunnerManagerSchema)` to create a new message.
 */
export const AvailableRunnerManagerSchema: GenMessage<AvailableRunnerManager> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_runner_manager, 19);

/**
 * @generated from enum gitpod.v1.RunnerManagerPhase
 */
export enum RunnerManagerPhase {
  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_ENABLED = 2;
   */
  ENABLED = 2,

  /**
   * @generated from enum value: RUNNER_MANAGER_PHASE_DISABLED = 3;
   */
  DISABLED = 3,
}

/**
 * Describes the enum gitpod.v1.RunnerManagerPhase.
 */
export const RunnerManagerPhaseSchema: GenEnum<RunnerManagerPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_manager, 0);

/**
 * @generated from enum gitpod.v1.RunnerManagerReleaseChannel
 */
export enum RunnerManagerReleaseChannel {
  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_STABLE = 1;
   */
  STABLE = 1,

  /**
   * @generated from enum value: RUNNER_MANAGER_RELEASE_CHANNEL_LATEST = 2;
   */
  LATEST = 2,
}

/**
 * Describes the enum gitpod.v1.RunnerManagerReleaseChannel.
 */
export const RunnerManagerReleaseChannelSchema: GenEnum<RunnerManagerReleaseChannel> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_runner_manager, 1);

/**
 * @generated from service gitpod.v1.RunnerManagerService
 */
export const RunnerManagerService: GenService<{
  /**
   * @generated from rpc gitpod.v1.RunnerManagerService.CreateRunnerManager
   */
  createRunnerManager: {
    methodKind: "unary";
    input: typeof CreateRunnerManagerRequestSchema;
    output: typeof CreateRunnerManagerResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerManagerService.GetRunnerManager
   */
  getRunnerManager: {
    methodKind: "unary";
    input: typeof GetRunnerManagerRequestSchema;
    output: typeof GetRunnerManagerResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerManagerService.UpdateRunnerManager
   */
  updateRunnerManager: {
    methodKind: "unary";
    input: typeof UpdateRunnerManagerRequestSchema;
    output: typeof UpdateRunnerManagerResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.RunnerManagerService.DeleteRunnerManager
   */
  deleteRunnerManager: {
    methodKind: "unary";
    input: typeof DeleteRunnerManagerRequestSchema;
    output: typeof DeleteRunnerManagerResponseSchema;
  },
  /**
   * Lists all runner managers with full details. Used by account principals for administration.
   *
   * @generated from rpc gitpod.v1.RunnerManagerService.ListRunnerManagers
   */
  listRunnerManagers: {
    methodKind: "unary";
    input: typeof ListRunnerManagersRequestSchema;
    output: typeof ListRunnerManagersResponseSchema;
  },
  /**
   * Lists available runner managers with minimal details. Used by users to select managed runners for their organization.
   *
   * @generated from rpc gitpod.v1.RunnerManagerService.ListAvailableRunnerManagers
   */
  listAvailableRunnerManagers: {
    methodKind: "unary";
    input: typeof ListAvailableRunnerManagersRequestSchema;
    output: typeof ListAvailableRunnerManagersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_runner_manager, 0);

